import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setGroupsBillingSettings } from '../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../root/tcsm-model';

export function useGroupsBillingSettings(groupsBillingSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.groupsBillingSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, groupsBillingSettingsId, { guid }, language, false, setGroupsBillingSettings));
		}

	}, []);

	return epiApiState?.groupsBillingSettingsState?.contentLoaded;

}